<script lang="ts">
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { PaymentMethod, PaymentMethodFee, PaymentMethodTypeEnum, PaymentMethodTypeFriendlyEnum } from '../../../modules/posApi/payment-methods/payment-methods'
    import type { CreatePaymentMethodsDto } from '../../../modules/posApi/payment-methods/dto/create-payment-method.dto'
    import type { UpdatePaymentMethodsDto } from '../../../modules/posApi/payment-methods/dto/update-payment-method.dto'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import ZinputTitle from '../../_common/z/zinput-title.svelte'
    import { createEventDispatcher, onMount } from 'svelte/internal'
    // ##############################################################################################################
    const dispatch = createEventDispatcher()

    const entityId = 'paymentMethodId'

    export let paymentMethodId = null
    export let form: boolean = false

    let entities: PaymentMethod[] = []
    let entity: PaymentMethod = new PaymentMethod()

    // opção vazia explícita: sem ela o select fica sem seleção visível enquanto o tipo está vazio
    const typeOptions = [
        { value: '', label: '' },
        ...Object.keys(PaymentMethodTypeEnum).map((key) => ({ value: key, label: PaymentMethodTypeFriendlyEnum[key] })),
    ]
    const installmentsOptions = Array.from({ length: 100 }, (_, index) => ({ value: index + 1, label: index + 1 + 'x' }))
    const receiptTypeOptions = [
        { value: 'full', label: 'Se parcelar recebo o valor todo de uma vez (antecipado)' },
        { value: 'installment', label: 'Se parcelar eu recebo cada parcela em uma data diferente' },
    ]

    async function editEntity(id: string) {
        try {
            show = true
            entity = new PaymentMethod()
            entity = await window.api.pos.paymentMethods.getOne(id)
            if (!entity.installmentsFee || entity.installmentsFee.length === 0) {
                entity.installmentsFee = [{ fee: entity.feePercentage, installment: 1 }]
            }
            generateFee(entity.installments)
            console.log('payment', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new PaymentMethod()
        entity.installmentsFee = []
        entity.installments = 1
        entity.feeFixed = 0
        step = 2
    }

    async function createEntity() {
        try {
            show = true
            if (entity.installments > 100) entity.installments = 100
            const dto: CreatePaymentMethodsDto = {
                feePercentage: entity.feePercentage,
                installments: entity.installments,
                installmentsFee: entity.installmentsFee,
                label: entity.label,
                comissionFeeDebt: entity.comissionFeeDebt,
                comissionFeeDebtAttendant: entity.comissionFeeDebtAttendant,
                billIntegration: entity.billIntegration,
                receiptInterval: entity.receiptInterval,
                receiptDelay: entity.receiptDelay,
                receiptType: entity.receiptType,
                feeFixed: entity.feeFixed,
                type: entity.type,
            }
            entity = await window.api.pos.paymentMethods.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            if (entity.installments > 100) entity.installments = 100
            const dto: UpdatePaymentMethodsDto = {
                feePercentage: entity.feePercentage,
                installments: entity.installments,
                installmentsFee: entity.installmentsFee,
                label: entity.label,
                comissionFeeDebt: entity.comissionFeeDebt,
                comissionFeeDebtAttendant: entity.comissionFeeDebtAttendant,
                billIntegration: entity.billIntegration,
                receiptInterval: entity.receiptInterval,
                receiptDelay: entity.receiptDelay,
                receiptType: entity.receiptType,
                feeFixed: entity.feeFixed,
                type: entity.type,
            }
            await window.api.pos.paymentMethods.update(entity[entityId], dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity[entityId]) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.pos.paymentMethods.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.showActs = true
        grid.title = 'Meios de Pagamento'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Meio de pagamento' }))
        grid.cols.push(new GridCol({ content: 'Data de cadastro', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.createdAt })
            line.slots.push({
                content: [
                    new GridButton({
                        label: 'Editar',
                        icon: faEdit,
                        callback: () => {
                            editEntity(item.paymentMethodId)
                        },
                    }),
                ],
            })
            grid.lines.push(line)
        }
        grid = grid
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.pos.paymentMethods.remove(entity[entityId])
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (paymentMethodId) {
                await editEntity(paymentMethodId)
            } else {
                newEntity()
            }
        }
    })

    function generateFee(totalInst: number) {
        if (!entity.installmentsFee) entity.installmentsFee = []
        if (entity.installmentsFee.length > totalInst) {
            entity.installmentsFee = entity.installmentsFee.slice(0, totalInst)
        } else {
            for (let inst = entity.installmentsFee.length; inst < totalInst; inst++) {
                const feeItem: PaymentMethodFee = {
                    fee: 0,
                    installment: inst + 1,
                }
                entity.installmentsFee.push(feeItem)
                if (inst > 100) break
            }
        }
        entity.installmentsFee = entity.installmentsFee
    }

    $: {
        generateFee(entity.installments)
    }

    function onTypeChange() {
        if (entity.paymentMethodId) return
        if (entity.type === PaymentMethodTypeEnum.bankslip) {
            entity.receiptInterval = 30
            entity.receiptDelay = 1
            entity.receiptType = 'installment'
            entity.billIntegration = true
            entity.installments = 6
            return
        }
        if (entity.type === PaymentMethodTypeEnum.money) {
            entity.receiptInterval = 0
            entity.receiptDelay = 0
            entity.receiptType = 'full'
            entity.billIntegration = false
            entity.installments = 1
            return
        }
        if (entity.type === PaymentMethodTypeEnum.check) {
            entity.receiptInterval = 30
            entity.receiptDelay = 1
            entity.receiptType = 'installment'
            entity.billIntegration = true
            entity.installments = 6
            return
        }
        if (entity.type === PaymentMethodTypeEnum.credit) {
            entity.receiptInterval = 30
            entity.receiptDelay = 30
            entity.receiptType = 'installment'
            entity.billIntegration = false
            entity.installments = 12
            return
        }
        if (entity.type === PaymentMethodTypeEnum.debit) {
            entity.receiptInterval = 1
            entity.receiptDelay = 0
            entity.receiptType = 'full'
            entity.billIntegration = false
            entity.installments = 1
            return
        }
        if (entity.type === PaymentMethodTypeEnum.pix) {
            entity.receiptInterval = 0
            entity.receiptDelay = 0
            entity.receiptType = 'full'
            entity.billIntegration = false
            entity.installments = 1
            return
        }
        if (entity.type === PaymentMethodTypeEnum.recurring) {
            entity.receiptInterval = 30
            entity.receiptDelay = 30
            entity.receiptType = 'installment'
            entity.billIntegration = true
            entity.installments = 12
            return
        }
        entity.receiptInterval = 0
        entity.receiptDelay = 0
        entity.receiptType = 'full'
        entity.billIntegration = false
    }
</script>

{#if step === 1}
    <Content footer={true}>
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.tools.payments.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Novo meio de pagamento" mobileHideLabel={true} on:click={newEntity} />
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid}></Zgrid>
        <LoadSpinner {show} />
    </Content>
{/if}
{#if step === 2}
    <Content footer={true}>
        <Zact>
            {#if !form}
                <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            {/if}
            <div class="spacer" />
            {#if window.store.token.permissions.tools.payments.write}
                {#if !!entity[entityId]}
                    <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
                {/if}
                <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
            {/if}
        </Zact>

        <Zframe title="Meio de Pagamento" class="h-space">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={4} sizeM={12} label="Nome" type="text" bind:value={entity.label} />
                <Zinput size={4} sizeM={12} label="Tipo" type="select" options={typeOptions} bind:value={entity.type} on:change={onTypeChange} />
                <Zinput size={4} sizeM={12} label="Parcelamento máximo" type="select" options={installmentsOptions} bind:value={entity.installments} />

                <ZinputTitle
                    title="Taxa fixa por recebimento"
                    label="Para cartões de crédito essa taxa será única independente da quantidade de parcelas. Para outros meios de pagamento essa taxa será multiplicada pela quantidade de parcelas."
                />
                <Zinput size={2} sizeM={6} label="Taxa fixa ({window.configs.currency})" type="number" bind:value={entity.feeFixed} />

                <ZinputTitle title="Taxas percentuais por parcelamento" />
                {#each entity.installmentsFee as feeItem}
                    <Zinput size={2} sizeM={6} label="{feeItem.installment}x %" type="number" bind:value={feeItem.fee} />
                {/each}

                <Zinput
                    size={6}
                    sizeM={12}
                    label="Descontar do vendedor custos PROPORCIONAIS do meio de pagamento"
                    type="toggle"
                    bind:value={entity.comissionFeeDebt}
                />
                <Zinput
                    size={6}
                    sizeM={12}
                    label="Descontar do atendente custos PROPORCIONAIS do meio de pagamento"
                    type="toggle"
                    bind:value={entity.comissionFeeDebtAttendant}
                />
            </ZContainer>
        </Zframe>

        <Zframe title="Configurações de recebimento" class="h-space">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={7} sizeM={12} label="Tipo de recebimento" type="select" options={receiptTypeOptions} bind:value={entity.receiptType} />
                {#if entity.receiptType === 'installment'}
                    <Zinput size={5} sizeM={12} label="Intervalo entre parcelas (dias)" type="number" bind:value={entity.receiptInterval} />
                {/if}

                <Zinput size={7} sizeM={12} label="Prazo para compensação (dias)" type="number" bind:value={entity.receiptDelay} />
                <ZContainerCol size={12}>
                    <div class="text-muted">Cheques geralmente são 2 dias úteis. Boletos geralmente 1 dia útil. Cartão de crédito geralmente 30 dias.</div>
                </ZContainerCol>

                <Zinput size={12} label="Lançar no Contas a Receber" type="toggle" bind:value={entity.billIntegration} />
                <ZContainerCol size={12}>
                    <div class="text-muted">
                        Caso este meio de pagamento exija acompanhamento, como boletos por exemplo, é recomendado lançar no 'Contas a Receber' para que você
                        tenha um melhor controle dos recebimentos.
                    </div>
                </ZContainerCol>
            </ZContainer>
        </Zframe>
        <LoadSpinner {show} />
    </Content>
{/if}
